import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      localStorage.setItem('token', res.data.access_token);
      const me = await api.get('/auth/me');
      setUser(me.data);
      navigate('/dashboard');
    } catch {
      setError('Невірний email або пароль');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-brand">
          <span className="login-mug">🍺</span>
          <h1 className="login-logo">Draft<b>Beer</b></h1>
        </div>
        <p className="login-sub">Система управління мережею магазинів</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="field">
            <label className="label">Email</label>
            <input type="email" placeholder="you@draftbeer.ua" autoComplete="username"
              value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="field">
            <label className="label">Пароль</label>
            <input type="password" placeholder="••••••••" autoComplete="current-password"
              value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {error && <div className="login-error">{error}</div>}
          <button className="btn btn-primary btn-lg btn-block" type="submit" disabled={busy}>
            {busy ? 'Вхід…' : 'Увійти'}
          </button>
        </form>

        <p className="login-foot muted">Draft Beer CRM · захищений вхід</p>
      </div>
    </div>
  );
}
